import { RIPPLING } from '@/integrations/modules/rippling/consts';
import { getRipplingDimensions, getRipplingPositions } from '@/integrations/modules/rippling/selectors/getPositions';
import type { RipplingPositionsData } from '@/integrations/modules/rippling/types';
import Integrations from '@/shared/api/integrations';
import type { WiwState } from '@/store';

import { createAsyncThunk } from '@reduxjs/toolkit';
import type { Map } from 'immutable';

export interface SaveRipplingPositionsPayload {
  job_dimension_id: string | null;
  matched: Map<number, string>;
}

export interface SaveRipplingPositionsResponse {
  data: {
    job_id?: string;
  };
}

export const saveRipplingPositions = createAsyncThunk(
  'rippling/savePositions',
  async (payload: SaveRipplingPositionsPayload, { rejectWithValue, dispatch }) => {
    try {
      const response = await Integrations.url(`/${RIPPLING}/v2/config/positions`).post(payload);
      await dispatch(optimisticallyUpdateRipplingPositions(payload));
      return response as SaveRipplingPositionsResponse;
    } catch (error) {
      return rejectWithValue(error);
    }
  },
);

export const optimisticallyUpdateRipplingPositions = createAsyncThunk(
  'rippling/optimisticallyUpdatePositions',
  async (payload: SaveRipplingPositionsPayload, { getState }) => {
    const state = getState() as WiwState;
    const ripplingPositions = getRipplingPositions(state);
    const ripplingDimensions = getRipplingDimensions(state);

    return {
      job_dimension_id: payload.job_dimension_id,
      matched: payload.matched,
      rippling: ripplingPositions,
      rippling_dimensions: ripplingDimensions,
    } as RipplingPositionsData;
  },
);
